var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMisVocesLila({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mis-voces-lila",
    transform: "translate(-41 -567)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_448",
    "data-name": "Elipse 448",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(46 571)",
    fill: "#8894de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_305",
    "data-name": "Trazado 305",
    d: "M9,15c-2.67,0-8,1.34-8,4v2H17V19C17,16.34,11.67,15,9,15Zm7.76-9.64L15.08,7.05a3.317,3.317,0,0,1,0,3.89l1.68,1.69a5.117,5.117,0,0,0,0-7.27ZM20.07,2,18.44,3.63a7.978,7.978,0,0,1,0,10.74L20.07,16A9.829,9.829,0,0,0,20.07,2Z",
    transform: "translate(41 566)",
    fill: "#8894de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_306",
    "data-name": "Trazado 306",
    d: "M0,0H24V24H0Z",
    transform: "translate(41 567)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMisVocesLila);
export default __webpack_public_path__ + "static/media/mis-voces-lila.182a48bee8b8275686f2cb05eedf3279.svg";
export { ForwardRef as ReactComponent };